import * as _ from 'lodash';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LogService } from '../../services/log.service';
import { NewsService } from '../../services/news.service';
import { RssFeed } from '../../types/rss-feed';
import { Application } from '../../types/application';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../services/session.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { HttpClient } from '@angular/common/http';

interface ReleaseNote {
  release: string;
  link: string;
  target: string;
}

interface Resource {
  title: string;
  link: string;
  target: string;
  showIfParam: string;
  isNew: boolean;
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  lodash = _;
  /* productList = [
    {
      showIf: () =>  this.showAppIfAuthorized(this.accessApp),
      title: 'MX Access Enhancements Reference Guide',
      link:
        'assets/data/MX_Access_Enhancements_Reference_Guide.pdf',
      target:
        'assets/data/MX_Access_Enhancements_Reference_Guide.pdf'
    },

    {
      showIf: () =>  this.showAppIfAuthorized(this.accessApp),
      title: 'MX Access User Guide',
      link:
        'assets/data/MX_Access_User_Guide.pdf',
      target:
        'assets/data/MX_Access_User_Guide.pdf'
    },
    {
      title: 'MX Notify User Guide',
      showIf: () =>  this.showAppIfAuthorized(this.notifyApp),
      link:
        'assets/data/MX_Notify_User_Guide.pdf',
      target:
        'assets/data/MX_Notify_User_Guide.pdf'
    },
    {
      title: 'MX Access FAQ',
      showIf: () =>  this.showAppIfAuthorized(this.accessApp),
      link:
        'assets/data/MX_Access_Frequently_Asked_Questions.pdf',
      target:
        'assets/data/MX_Access_Frequently_Asked_Questions.pdf'
    },
    {
      title: 'MX Notify FAQ',
      showIf: () =>  this.showAppIfAuthorized(this.notifyApp),
      link:
        'assets/data/MX_Notify_Frequently_Asked_Questions.pdf',
      target:
        'assets/data/MX_Notify_Frequently_Asked_Questions.pdf'
    },
    {
      title: 'MX Policies',
      link:
        'assets/data/MX-Policies-Effective-07-31-2022.pdf',
      target:
        'assets/data/MX-Policies-Effective-07-31-2022.pdf'
    },
  ]; */

  ReleaseNotesList: ReleaseNote[] = [];
  productList: Resource[]=[];
  public mostRecentReleaseDate="";
  
  rssFeed: RssFeed;

  ellipsisSize: number;

  initializeResize = false;

  cognitoGroups: string[];
  accessApp: any;
  notifyApp: any;

  longMonth: string;
  displayMessage:number;
  isNewsDisplay=true;

  showAnnouncement=false;
  AnnouncementText="";
  LinkText="";
  AnnouncementURL="";

  @Output()
  onItemSelected: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private log: LogService,
    private news: NewsService,
    private session: SessionService,
    private httpClient: HttpClient
  ) {}

  ngOnInit() {
    const env = environment.applications;
    try{
      this.loadInformation();
      console.log("After loadInformation");

    }
    catch{
      this.log.trace('RecentReleaseDate conversion failed');
      this.displayMessage=2;
      this.isNewsDisplay=false;
    }
    this.accessApp = env.access;
    this.notifyApp = env.notify;
    this.cognitoGroups = this.session.getUser().securityGroups;
    
    this.log.trace('Reached Oninit end');
  }

  showAdminIfAuthorized() {
    return _.find(this.cognitoGroups, group => {
      return (
        group === 'app-access-mxadmin' ||
        group === 'app-access-participantadmin' ||
        group === 'app-notify-participantadmin'
      );
    });
  }
 
  /* showAppIfAuthorized(application) {
    const appName = _.toLower(application.name),
      ignoredRoles = _.get(application, 'ignoredRoles', []);
    return !_.isEmpty(
      _.filter(
        this.cognitoGroups,
        group =>
          _.startsWith(group, `app-${appName}`) &&
          !_.includes(ignoredRoles, group)
      )
    );
  } */
  
  showAppIfAuthorized(appName) {
    const env = environment.applications;
    let application;
    let  ignoredRoles;
    if (appName=="access") {
      application=env.access;
      ignoredRoles = _.get(application, 'ignoredRoles', []);
    }
    if (appName=="notify") {
      application=env.notify;
      ignoredRoles = _.get(application, 'ignoredRoles', []); 
    }
    
    return !_.isEmpty(
      _.filter(
        this.cognitoGroups,
        group =>
          _.startsWith(group, `app-${appName}`) &&
          !_.includes(ignoredRoles, group)
      )
    );
  }

  selectItem(item) {
    this.onItemSelected.emit(item.link);
  }

  /* getProductList() {
    return _.filter(
      this.productList,
      item => (item.showIf ? item.showIf() : true)
    );
  } */
    getProductList() {
      return _.filter(
        this.productList,
        item => (item.showIfParam ? this.showAppIfAuthorized(item.showIfParam) : true)
      );
    }

  getReleaseList() {
    if (this.ReleaseNotesList ==null){
      this.log.trace('Release notes null')
    }
    return this.ReleaseNotesList;
  }
  getNewsTitle(item) {
    const title = `${item.pubDate} - ${item.title}`;
    return title.length > this.ellipsisSize
      ? `${title.slice(0, this.ellipsisSize)}...`
      : title;
  }

  setEllipsisSize(size) {
    this.ellipsisSize = size;
  }

  loadInformation() {
    const notelist=environment.releasenotelist;
    const self = this; 
    
    this.httpClient.get<{ releaseNotes: ReleaseNote[], resourceList: Resource[],releasedate: string,annoucement: string, annoucementlink: string, linkText: string }>(notelist)
      .subscribe(
        (data) => {
          self.ReleaseNotesList = data.releaseNotes.map(note => ({
            release: note.release,
            link: note.link,
            target: note.target
          }));
          self.productList=data.resourceList.map(resource=>(
            {
              title: resource.title,
              link: resource.link,
              target: resource.target,
              showIfParam: resource.showIfParam,
              isNew: resource.isNew
            }
          )

          )
          self.mostRecentReleaseDate = data.releasedate;
          self.AnnouncementText=data.annoucement;
          self.AnnouncementURL=data.annoucementlink;
          self.LinkText=data.linkText;

          if (self.AnnouncementText.length>0) {
            self.showAnnouncement=true;
          }

          var releaseDate = new Date(this.mostRecentReleaseDate);

          var releaseMonth = '';
          if (releaseDate.getMonth()==0)
            releaseMonth='January'
          else if (releaseDate.getMonth()==1)
            releaseMonth='February'
          else if (releaseDate.getMonth()==2)
            releaseMonth='March'
          else if (releaseDate.getMonth()==3)
            releaseMonth='April'
          else if (releaseDate.getMonth()==4)
            releaseMonth='May'
          else if (releaseDate.getMonth()==5)
            releaseMonth='June'
          else if (releaseDate.getMonth()==6)
            releaseMonth='July'
          else if (releaseDate.getMonth()==7)
            releaseMonth='August'
          else if (releaseDate.getMonth()==8)
            releaseMonth='September'
          else if (releaseDate.getMonth()==9)
            releaseMonth='October'
          else if (releaseDate.getMonth()==10)
            releaseMonth='November'
          else if (releaseDate.getMonth()==11)
            releaseMonth='December'

          var releaseYear = releaseDate.getFullYear();
          self.longMonth=releaseMonth+' '+releaseYear
            
          releaseDate.setDate(releaseDate.getDate() + 7 );
          var todaysDate = new Date(Date.now());
          self.log.trace('todays date->'+todaysDate.toJSON());
          if (todaysDate < releaseDate){
            self.log.trace('below 7 days'+todaysDate+'-'+releaseDate)
            self.displayMessage=1;
            self.isNewsDisplay=true;
          }else{
            self.log.trace('above 7 days'+todaysDate+'-'+releaseDate)
            self.displayMessage=2;
            self.isNewsDisplay=false;
          }
        },
        (error) => {
          console.error('Error loading release notes:', error);
        }
      );
  }

}

